import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import EditMember from './EditMember'

class ParselEditMember extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={EditMember} {...props}/>
   )
 }
}



export default ParselEditMember;
